import React from "react";
import { t } from "../../../i18n";
import { NavLink } from "react-router-dom";

const ProfileNavigation = ({ toRender, pointBlockLabel }) => {
  return (
    <nav className="profile-navigation">
      <NavLink
        className="profile-navigation-link"
        activeClassName="profile-navigation-link-active"
        to="/profile"
        exact
      >
        {t("gamification2026.profile.personal-data")}
      </NavLink>
      <NavLink
        className="profile-navigation-link"
        activeClassName="profile-navigation-link-active"
        to="/profile/balance"
      >
        {t("gamification2026.profile.balance")}
      </NavLink>
      <NavLink
        className="profile-navigation-link"
        activeClassName="profile-navigation-link-active"
        to="/profile/orders"
      >
        {t("gamification2026.profile.orders")}
      </NavLink>
      {toRender("Bloqueio de Pontos") && (
        <NavLink
          className="profile-navigation-link"
          activeClassName="profile-navigation-link-active"
          to="/profile/history_point_blocks"
        >
          {t("gamification2026.profile.objectives")}
        </NavLink>
      )}
      {toRender("Cartões Recarregáveis") && (
        <NavLink
          className="profile-navigation-link"
          activeClassName="profile-navigation-link-active"
          to="/profile/cards"
        >
          {t("gamification2026.profile.cards")}
        </NavLink>
      )}
    </nav>
  );
};

const ProfileLayout = (props) => {
  return (
    <div className="profile-layout">
      <ProfileNavigation {...props} />
      {props.children}
    </div>
  );
};

export default ProfileLayout;
